module.exports = __webpack_public_path__ + "static/media/call_full.5cbc3d5.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/sounds/call_full.mp3
// module id = 381
// module chunks = 1